import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AuthState {
  token: string | null;
  refreshToken: string | null;
  isAuthenticated: boolean;
  login: (jwt: string, refreshToken: string) => void;
  logout: () => void;
  setTokens: (jwt: string, refreshToken: string) => void;
}

const TOKEN_KEY = "jwt";
const REFRESH_TOKEN_KEY = "refreshToken";

const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      refreshToken: null,
      isAuthenticated: false,
      login: (jwt: string, refreshToken: string) => {
        set({ token: jwt, refreshToken, isAuthenticated: true });
      },
      logout: () => {
        set({ token: null, refreshToken: null, isAuthenticated: false });
      },
      setTokens: (jwt: string, refreshToken: string) => {
        set({ token: jwt, refreshToken, isAuthenticated: true });
      },
    }),
    {
      name: "auth-storage",
      partialize: (state) => ({
        token: state.token,
        refreshToken: state.refreshToken,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);
export default useAuthStore;
